// components/Desktop/Components/Safe.js
import React from 'react';
import styles from './Safe.module.css';

// Replace with your actual image paths
import asset1 from '../../../assets/safe-asset-2.png';
import asset2 from '../../../assets/safe-asset-1.png';
import asset3 from '../../../assets/safe-asset-4m.png';
import asset4 from '../../../assets/safe2-asset-5.png';
import asset5 from '../../../assets/safe2-asset-1.png';

const Safe = () => {
  return (
    <section className={styles.safeSection}>
      {/* Background Images */}
      <div className={styles.imageSection}>
      <img src={asset1} alt="Asset 1" className={styles.asset1} />
      <img src={asset2} alt="Asset 2" className={styles.asset2} />
      <img src={asset3} alt="Asset 3" className={styles.asset3} />
      <img src={asset4} alt="Asset 4" className={styles.asset4} />
      <img src={asset5} alt="Asset 5" className={styles.asset5} />
      </div>
      {/* Text Content */}
      <h1 className={styles.safeTitle}>SAFE</h1>
      <h2 className={styles.greenSubtitle}>User-backed trust ratings</h2>
      <h2 className={styles.blackSubtitle}>made to foster trust and community</h2>
    </section>
  );
};

export default Safe;
